(function (angular) {
	'use strict';

	var dynamicDateTemplate =
		'<div class="field-group">' +
			'<div class="field-label">' +
				'<label>{{dropdown.label}}</label>' +
			'</div>' +
			'<div class="fields delta mt-25">' +
				'<div class="clearfix">' +
					'<div class="select-holder mr-50 float-left">' +
						'<select ' +
								'ng-options="month as month.label for month in dropdown.months track by month.value" ' +
								'ng-model="dropdown.month" ' +
								'ng-change="dropdown.updateDaysToReflectMonth()" ' +
								'name="{{dropdown.monthPathName}}">' +
						'</select>' +
						'<div class="select-mask">' +
							'<span class="text">{{dropdown.month.label}}</span>' +
						'</div>' +
					'</div>' +
					'<div class="select-holder mr-50 float-left">' +
						'<select ' +
								'ng-options="day for day in dropdown.days track by day" ' +
								'ng-model="dropdown.day" ' +
								'ng-change="dropdown.formatDate()" ' +
								'name="{{dropdown.dayPathName}}">' +
						'</select>' +
						'<div class="select-mask">' +
							'<span class="text">{{dropdown.day}}</span>' +
						'</div>' +
					'</div>' +
					'<div class="select-holder float-left">' +
						'<select ' +
								'ng-options="year for year in dropdown.years track by year" ' +
								'ng-model="dropdown.year" ' +
								'ng-change="dropdown.updateDaysToReflectYear()" ' +
								'name="{{dropdown.yearPathName}}">' +
						'</select>' +
						'<div class="select-mask">' +
							'<span class="text">{{dropdown.year}}</span>' +
						'</div>' +
					'</div>' +
				'</div>' +
			'</div>' +
		'</div>';

	var dynamicDateDropdownObject = {
		template: dynamicDateTemplate,
		bindings: {
			label: '@',
			monthPathName: '@',
			dayPathName: '@',
			yearPathName: '@',
			month: '=?',
			day: '=?',
			year: '=?',
			dateType: '@?',
			formattedDate: '=?'
		},
		controller: [
			'$filter',
			'CORPORATION_YEARS',
			'DOB_MONTHS',
			'DOB_YEARS',
			DynamicDateDropdownFunction
		],
		controllerAs: 'dropdown'
	};

	angular
		.module('formValidationModule')
		.component('dynamicDateDropdown', dynamicDateDropdownObject);

	function DynamicDateDropdownFunction(
		$filter,
		CORPORATION_YEARS,
		DOB_MONTHS,
		DOB_YEARS) {

		var dropdown = this;

		dropdown.months = DOB_MONTHS;

		function updateYears() {
			dropdown.years = dropdown.dateType === 'corporation' ? CORPORATION_YEARS() : DOB_YEARS();
		}

		dropdown.$onInit = function(){
			updateYears();

			if (dropdown.day === null || angular.isUndefined(dropdown.day)) {
				updateDaysArray(31);
				dropdown.day = dropdown.days[0];
			}

			if (dropdown.year === null || angular.isUndefined(dropdown.year)) {
				dropdown.year = dropdown.years[0];
			}

			if (dropdown.month === null || angular.isUndefined(dropdown.month)) {
				dropdown.month = dropdown.months[0];
				updateDaysArray(31);
			} else {
				dropdown.month = $filter('filter')(dropdown.months, {value: parseInt(dropdown.month)})[0];
				dropdown.updateDaysToReflectMonth();
			}

			dropdown.formatDate();
		};

		 dropdown.formatDate = function() {
			var formattedMonth = formatValue(dropdown.month.value);
			var formattedDay = formatValue(dropdown.day);

			dropdown.formattedDate = dropdown.year + '-' + formattedMonth + '-' + formattedDay;
		 };

		function formatValue(value) {
			return value < 10 ? '0' + value : value.toString();
		}

		var monthsWith30Days = [4, 6, 9, 11];

		dropdown.updateDaysToReflectMonth = function(){
			var lastDay = 31;

			if (monthsWith30Days.indexOf(dropdown.month.value) !== -1) {
				lastDay = 30;
			} else if (dropdown.month.value === 2) {
				lastDay = getDaysInFebruary();
			}

			updateDaysArray(lastDay);
			dropdown.formatDate();
		};

		dropdown.updateDaysToReflectYear = function(){
			if (dropdown.month.value === 2) {
				if (getDaysInFebruary() !== dropdown.days.length) {
					var lastDay = getDaysInFebruary();

					updateDaysArray(lastDay);
				}
			}
			dropdown.formatDate();
		};

		function updateDaysArray(lastDay){
			var days = [];

			for (var i=1; i<=lastDay; i++) {
				days.push(i);
			}

			if(dropdown.day > lastDay) {
				dropdown.day = lastDay;
			}

			dropdown.days = days;
		}

		function getDaysInFebruary(){
			var isLeap = new Date(dropdown.year, 1, 29).getDate() === 29;

			return isLeap ? 29 : 28;
		}

		dropdown.$onChanges = function(changesObj) {
			if (angular.isDefined(changesObj.dateType) && !changesObj.dateType.isFirstChange()) {
				updateYears();
				dropdown.year = $filter('filter')(dropdown.years, dropdown.year)[0] || dropdown.years[0];
			}
		};
	}
})(window.angular);